<div class="page-layout carded fullwidth inner-scroll">

    <!-- TOP BACKGROUND -->
    <div class="top-bg primary"></div>
    <!-- / TOP BACKGROUND -->

    <!-- CENTER -->
    <div class="center" style="width: 100%;">

        <!-- CONTENT HEADER -->
        <div class="header primary p-24" fxLayout="row" fxLayoutAlign="start center">
        </div>
        <!-- / CONTENT HEADER -->

        <!-- CONTENT CARD -->
        <div class="content-card " style="border-color: transparent">
            <img src="./assets/images/norm35/Mesa de trabajo 8.png" alt="Logo-Norm35" class="centradoIMG ">
        </div>
        <!-- / CONTENT -->

    </div>
    <!-- / CONTENT CARD -->
    <!-- CONTENT -->
    <div class="content-card" style="margin-top: 2%; margin-left: 5%; margin-right: 15%;">

        <p> Los siguientes aspectos están documentados en esta sección: </p><br><br>
        <div class="container">
            <div *ngFor="let datita of dataLink">
                <p>
                    <a target="_blank" href="./NOM35/wizard/{{datita.ruta}}">{{datita.name}}</a>
                </p>
                <div *ngFor="let subdatita of dataSubLink">
                    <ul *ngIf=" datita.idLink == subdatita.idSubLink ">
                        <a target="_blank" href="./NOM35/wizard/{{subdatita.ruta}}">{{subdatita.name}}</a>
                    </ul>

                </div>
            </div>
        </div>


        <li>8.2 Las acciones y programas para la prevención de los factores de riesgo psicosocial, la promoción de un entorno ...

            <ul> 8.2 a) En relación con el liderazgo y las relaciones en el trabajo deberán incluir </ul>
            <ul> b) Respecto a las cargas de trabajo deberán contener </ul>
            <ul> 8.2 c) En lo que se refiere al control de trabajo deberán comprender </ul>
            <ul> 8.2 d) En lo relativo al apoyo social deberán incluir actividades que permitan </ul>
            <ul> 8.2 e) En relación con el equilibrio en la relación trabajo-familia, contemplar </ul>
            <ul> 8.2 f) Respecto al reconocimiento en el trabajo deberán contar con mecanismos que permitan </ul>
            <ul> 8.2 g) En lo que se refiere a la prevención de la violencia laboral se deberá </ul>
            <ul> 8.2 h) En relación con la información y comunicación que se proporciona a los trabajadores </ul>
            <ul> 8.2 i) Respecto a la capacitación y adiestramiento que se proporciona a los trabajadores se deberá </ul>
        </li>




    </div>

</div>
<!-- / CENTER -->
